import React from 'react'

import useStyles from './splash.style'

const Splash = props => {
  const classes = useStyles(props)
  return (
    <div className={classes.container}>
      <img
        alt='logo'
        className={classes.icon}
        src={require('../../assets/img/omnilert_logo.png')}
      />
    </div>
  )
}

export default Splash
